// Web sitesi verileri – tüm diller için açıklamalar burada
const websites = [
    {
        id: "kochan-productions",
        name: "Kochan Productions",
        url: "https://kochanproductions.com",
        desc_tr: "Profesyonel video prodüksiyon ve sosyal medya yönetimi hizmetleri sunan kurumsal web sitesi.",
        desc_en: "Corporate website offering professional video production and social media management services.",
        desc_ar: "موقع مؤسسي يقدم خدمات إنتاج الفيديو الاحترافية وإدارة وسائل التواصل الاجتماعي.",
    },
    {
        id: "mans-films",
        name: "Mans Films",
        url: "https://www.mansfilms.com",
        desc_tr: "Film yapımcılığı ve sinema prodüksiyon hizmetleri sunan yaratıcı ajans web sitesi.",
        desc_en: "Creative agency website offering filmmaking and cinema production services.",
        desc_ar: "موقع وكالة إبداعية يقدم خدمات صناعة الأفلام والإنتاج السينمائي.",
    },
    {
        id: "av-turabi-tilki",
        name: "Av. Turabi Tilki Hukuk Bürosu",
        url: "https://www.avturabitilki.com.tr",
        desc_tr: "Hukuk bürosu kurumsal web sitesi. Profesyonel hukuk danışmanlığı ve avukatlık hizmetleri.",
        desc_en: "Law firm corporate website. Professional legal consultancy and attorney services.",
        desc_ar: "الموقع الرسمي لمكتب المحاماة. استشارات قانونية مهنية وخدمات المحاماة.",
    },
    {
        id: "by-genco",
        name: "By Genco",
        url: "https://www.bygenco.com",
        desc_tr: "Marka ve tasarım hizmetleri sunan kurumsal web sitesi.",
        desc_en: "Corporate website offering brand and design services.",
        desc_ar: "موقع مؤسسي يقدم خدمات العلامة التجارية والتصميم.",
    },
    {
        id: "tokyapi-proje",
        name: "Tokyapı Proje",
        url: "https://www.tokyapiproje.com",
        desc_tr: "İnşaat ve proje geliştirme alanında hizmet veren kurumsal web sitesi.",
        desc_en: "Corporate website serving in construction and project development.",
        desc_ar: "موقع مؤسسي يخدم في مجال البناء وتطوير المشاريع.",
    },
    {
        id: "cengelkoy-kuran-kursu",
        name: "Çengelköy Kerime Hatun Kur'an Kursu",
        url: "https://www.cengelkoykerimehatunkurankursu.com",
        desc_tr: "Eğitim kurumu tanıtım ve bilgilendirme web sitesi.",
        desc_en: "Educational institution promotional and informational website.",
        desc_ar: "موقع ترويجي ومعلوماتي للمؤسسة التعليمية.",
    },
    {
        id: "yikad",
        name: "YİKAD",
        url: "https://www.yikad.org.tr",
        desc_tr: "Yalova İnsan Kaynakları Derneği kurumsal web sitesi.",
        desc_en: "Yalova Human Resources Association corporate website.",
        desc_ar: "الموقع الرسمي لجمعية يالوفا للموارد البشرية.",
    },
    {
        id: "vertiqa-asansor",
        name: "Vertiqa Asansör",
        url: "https://vertiqaasansor.com",
        desc_tr: "Asansör sistemleri üretim ve montaj hizmetleri sunan kurumsal web sitesi.",
        desc_en: "Corporate website offering elevator systems production and installation services.",
        desc_ar: "موقع مؤسسي يقدم خدمات إنتاج وتركيب أنظمة المصاعد.",
    },
];

export default websites;
